import {request} from '../utils/request'
export function menualAudit(url, parameter) {
    return request({
      url: url,
      method: 'post',
      data: parameter,
    //   headers: {
    //     'Content-Type': 'application/json' // 文件上传
    //   }
    })
  }
  

  export function bankAudit(url) {
      console.log(url,"请求地址")
        return request({
        url: url,
        method: 'get'
       
        })
  }
  


// WEBPACK FOOTER //
// ./src/api/creditPayment.js